// removed by extract-text-webpack-plugin
module.exports = {"FlashModal":"FlashModal__-loca-__3NKC1","Text":"FlashModal__-loca-__2LrPT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/FlashModal/FlashModal.css
// module id = 192
// module chunks = 0